import { Dispatch } from "redux";

import { ActionType } from "@seneca/session-service-consts";

import { queryClient } from "services";
import {
  getXpQueryOptions,
  XP_SERVICE_QUERY_KEY,
  XpRewardsQueryKey
} from "services/xpService/queries";
import { QuizXp } from "services/xpService/types";

import { fetchClassLeaderboardsForCourse } from "seneca-common/features/class-leaderboards/service";
import updateSessionXp from "seneca-common/features/session/actions/updateSessionXp";
import { RewardType } from "seneca-common/features/session/models/SessionXp";

import { analyticsUpdateQuizSessionXp } from "features/classroom/pages/quiz-session/analytics";
import { logExamQuestionUpdateSessionXp } from "features/exam-questions/analytics";

import { updateSessionXp as updateEqSessionXp } from "../routes/classroom/routes/course/routes/course-exam-questions/EQSessionContext/useEqSessionReducer";

type SessionDeps = {
  dispatch: React.Dispatch<any>;
  sessionId: string;
  courseId: string;
};

export function makeHandleSessionXpMessage(deps: SessionDeps) {
  const { dispatch, sessionId, courseId } = deps;

  return (messageEvent: MessageEvent) => {
    const { action, data } = JSON.parse(messageEvent.data);
    if (action === ActionType.SESSION_XP) {
      dispatch(updateSessionXp({ sessionId, xp: data }));
      dispatch(fetchClassLeaderboardsForCourse(courseId!));
      if (data.reward?.type === RewardType.FREEMIUM) {
        queryClient.invalidateQueries({
          queryKey: XpRewardsQueryKey
        });
      }
      queryClient.invalidateQueries({
        queryKey: [XP_SERVICE_QUERY_KEY]
      });
    }
  };
}

type EqSessionDeps = {
  dispatch: React.Dispatch<any>;
  reduxDispatch: Dispatch<any>;
  sessionId: string;
  assignmentId?: string;
  source?: string;
};

export function makeHandleEqSessionXpMessage(deps: EqSessionDeps) {
  const { dispatch, sessionId, reduxDispatch, assignmentId, source } = deps;

  return (messageEvent: MessageEvent) => {
    const { action, data } = JSON.parse(messageEvent.data);
    if (action === ActionType.EXAM_QUESTION_XP) {
      const { breakdown, newXp, questionId } = data;

      dispatch(updateEqSessionXp(data));

      reduxDispatch(updateEqSessionXp(data));

      if (data.reward?.type === RewardType.FREEMIUM) {
        queryClient.invalidateQueries({
          queryKey: XpRewardsQueryKey
        });
      }
      queryClient.invalidateQueries({ queryKey: [XP_SERVICE_QUERY_KEY] });
      logExamQuestionUpdateSessionXp({
        newXp,
        breakdown,
        questionId,
        sessionId,
        assignmentId,
        source
      });
    }
  };
}

export function makeHandleQuizSessionXpMessage(quizId: string) {
  return (messageEvent: MessageEvent) => {
    const { action, data } = JSON.parse(messageEvent.data);
    if (action === ActionType.USER_QUIZ_XP) {
      const quizXp = data as QuizXp;
      queryClient.invalidateQueries(getXpQueryOptions({ quizId }));
      analyticsUpdateQuizSessionXp(quizXp);
      return quizXp;
    }
  };
}
